type SowIconProps = React.SVGProps<SVGSVGElement>;

const SowIcon: React.FC<SowIconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      {...props}
    >
      <path
        d="M47.4789 20.6216L19.9363 37.0445V64.5254L47.4789 48.1024V20.6216Z"
        fill="#7C612E"
      />
      <path
        d="M18.4125 37.1168L19.9363 38.0044V64.5254L18.4125 63.6378V37.1168Z"
        fill="#DDB96E"
      />
      <path
        d="M78.8375 37.3135L77.108 38.3564L47.4723 20.6211V18.7881L78.8375 37.3135Z"
        fill="#F9E4B9"
      />
      <path
        d="M76.9756 35.1742L45.8649 53.6325L47.6299 54.6741L78.8254 36.2695L76.9756 35.1742Z"
        fill="#F9E4B9"
      />
      <path
        d="M28.7744 55.2258L36.6796 59.9625V72.3413L28.7744 67.6047V55.2258Z"
        fill="#DDB96E"
      />
      <path
        d="M28.7732 55.2264L36.6794 59.9624L47.0434 53.7443L39.1346 49.0083L28.7732 55.2264Z"
        fill="#F9E4B9"
      />
      <path
        d="M36.6797 59.9623L47.0434 53.7441V66.123L36.6797 72.3412V59.9623Z"
        fill="#7C612E"
      />
      <path
        d="M37.4798 56.5399C36.0037 56.5397 34.8069 55.7969 34.8067 54.8807L34.8068 54.6269L34.8071 40.4828L40.1536 40.4835L40.1529 54.6267L40.1536 54.88C40.1536 55.7964 38.9562 56.5399 37.4798 56.5399Z"
        fill="#DDB96E"
      />
      <path
        d="M37.4623 54.6044L37.4531 54.6041L37.4509 53.3131L37.446 52.795L37.4496 52.7952L37.4267 40.3142L40.1533 40.3141L40.1531 54.6262L40.1522 54.6267L40.153 54.88C40.1528 55.7963 38.9563 56.5393 37.48 56.5394L37.4623 54.6044Z"
        fill="#BB9446"
      />
      <path
        d="M18.4127 37.115L48.7667 55.2976L78.8296 37.2568L48.4652 19.0742L18.4127 37.115Z"
        fill="#BB9446"
      />
      <path
        d="M18.4121 37.1152L48.7694 55.3021L48.7803 57.4533L18.4126 39.2664L18.4121 37.1152Z"
        fill="#DDB96E"
      />
      <path
        d="M46.9942 56.0586L48.7803 57.0357V82.5001L46.9942 81.523V56.0586Z"
        fill="#DDB96E"
      />
      <path
        d="M46.9944 54.2438L48.727 55.3311L61.9956 39.0907L60.2302 38.0278L46.9944 54.2438Z"
        fill="#DDB96E"
      />
      <path
        d="M48.7477 55.2833L61.9665 39.0901L78.7981 37.2563V64.8453L48.7477 82.4962V55.2833Z"
        fill="#7C612E"
      />
      <path
        d="M20.1387 38.1864L32.9988 21.647L50.1851 20.143V21.4154L20.1387 38.1864Z"
        fill="#7C612E"
      />
      <path
        d="M48.3217 30.2991L42.9152 27.2992L44.4934 26.388L49.9 29.3879L48.3217 30.2991Z"
        fill="#F9E4B9"
      />
      <path
        d="M32.0696 37.9316L37.4205 41.1369L42.7201 37.9566L37.3674 34.7513L32.0696 37.9316Z"
        fill="#F9E4B9"
      />
      <path
        d="M32.0704 37.931L37.4206 41.1368V42.9592L32.0704 39.7534V37.931Z"
        fill="#DDB96E"
      />
      <path
        d="M37.4205 41.1369L42.7219 37.9547V39.7771L37.4205 42.9593V41.1369Z"
        fill="#7C612E"
      />
      <path
        d="M40.1193 37.3751H34.9113V31.212C35.0599 31.4361 35.2748 31.6347 35.5363 31.797C36.0478 32.1145 36.7477 32.3077 37.5148 32.3077C38.282 32.3077 38.9826 32.1146 39.4943 31.797C39.7557 31.6347 39.9706 31.4361 40.1193 31.212V37.3751Z"
        fill="#DDB96E"
        stroke="black"
        strokeWidth="0.223045"
      />
      <path
        d="M37.5146 39.4318C36.0153 39.4317 34.7996 38.6768 34.7993 37.7462L34.7991 35.0896L34.7996 35.0905L34.7994 30.5101L40.2303 30.5105L40.2299 37.4863L40.2291 37.4868L40.2297 37.7458C40.2297 38.6766 39.0142 39.4318 37.5146 39.4318Z"
        fill="#DDB96E"
      />
      <path
        d="M37.4972 37.477L37.488 37.4766L37.4606 30.5113L40.2301 30.5113L40.2293 35.09L40.2301 35.0895L40.2303 37.7461C40.2303 38.6769 39.0143 39.4312 37.5147 39.4312L37.4972 37.477Z"
        fill="#BB9446"
      />
      <path
        d="M35.1594 32.0079C34.4099 30.7093 34.8553 29.0486 36.1539 28.2989C36.9472 27.8411 37.874 27.8319 38.6472 28.1877L38.6476 28.1864L38.6549 28.1912C38.6949 28.2098 38.7343 28.2296 38.7735 28.2502L42.854 30.2943L48.5043 27.0321L51.2196 31.7352L44.2973 35.7318C43.4036 36.2454 42.3389 36.1951 41.5183 35.6899L36.4529 33.1488C35.9276 32.9267 35.4665 32.5399 35.1594 32.0079Z"
        fill="#F9E4B9"
      />
      <path
        d="M36.1563 33.0081C34.8576 32.2583 34.4124 30.5968 35.1622 29.2981L35.2812 29.0998L35.3249 29.1286L43.1713 33.2542L49.3655 29.6781L50.7229 32.0292L44.3046 35.7347C43.4097 36.2514 42.3431 36.2008 41.5209 35.6944L36.4704 33.1616C36.3641 33.1172 36.2587 33.0672 36.1563 33.0081Z"
        fill="#DDB96E"
      />
      <path
        d="M61.9961 37.8795L81.5872 35.8033L81.5873 37.0055L61.996 39.0915L61.9961 37.8795Z"
        fill="#F2D497"
      />
      <path
        d="M61.9957 37.8787L31.2363 19.368L31.2364 20.5702L61.9956 39.0907L61.9957 37.8787Z"
        fill="#F2D497"
      />
      <path
        d="M50.5158 17.5L81.5877 35.8042L62.0064 37.8996L31.2458 19.3753L50.5158 17.5Z"
        fill="#F9E4B9"
      />
      <path
        d="M18.4142 37.1118L20.1653 38.1684L33.0226 21.6491L31.2572 20.5862L18.4142 37.1118Z"
        fill="#DDB96E"
      />
    </svg>
  );
};

export default SowIcon;
